// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"144":"0820c108","840":"23a88a0f"}[chunkId] + ".css";
};